import { Routes } from '@angular/router';
import {NotFoundComponent} from "./components/pages/not-found/not-found.component";
import {AdminGuard} from "./guard/admin.guard";

import { SignInComponent } from './components/pages/sign-in/sign-in.component';

import { AdminsComponent } from './components/pages/admins/admins.component';
import { MenuManagerComponent } from './components/pages/menu-manager/menu-manager.component';
import { PostsComponent } from './components/pages/posts/posts.component';
import { SettingComponent } from './components/pages/setting/setting.component';
import { FileManagerComponent } from './components/layout/file-manager/file-manager.component';
import { TeamComponent } from './components/pages/team/team.component';
import { LogsComponent } from './components/pages/logs/logs.component';
import { BannerComponent } from './components/pages/banner/banner.component';
import { FormsComponent } from './components/pages/forms/forms.component';
import { FaqComponent } from './components/pages/faq/faq.component';
import { GalleryComponent } from './components/pages/gallery/gallery.component';
import { LiveRecordingsComponent } from './components/pages/live-recordings/live-recordings.component';
import { CommentsComponent } from './components/pages/comments/comments.component';
import { CalendarComponent } from './components/pages/calendar/calendar.component';

export const routes: Routes = [
  {path: '', component: MenuManagerComponent, canActivate: [AdminGuard], data: { permission: '' }},
  {path: 'menu', component: MenuManagerComponent, canActivate: [AdminGuard],   data: { permission: 'menus_view' }},
  { path: 'calendar', component: CalendarComponent, canActivate: [AdminGuard], data: { permission: 'calendar' } },
  { path: 'team', component: TeamComponent, canActivate: [AdminGuard], data: { permission: 'team' } },
  { path: 'posts', component: PostsComponent, canActivate: [AdminGuard], data: { permission: 'posts' } },
  { path: 'banner', component: BannerComponent, canActivate: [AdminGuard], data: { permission: 'slider' } },
  { path: 'forms', component: FormsComponent, canActivate: [AdminGuard], data: { permission: 'forms' } },
  { path: 'faq', component: FaqComponent, canActivate: [AdminGuard], data: { permission: 'faq' } },
  { path: 'gallery', component: GalleryComponent, canActivate: [AdminGuard], data: { permission: 'gallery' } },
  { path: 'live', component: LiveRecordingsComponent, canActivate: [AdminGuard], data: { permission: 'live' } },
  { path: 'comments', component: CommentsComponent, canActivate: [AdminGuard], data: { permission: 'comments' } },
  { path: 'admins', component: AdminsComponent, canActivate: [AdminGuard], data: { permission: 'admins' } },
  { path: 'setting', component: SettingComponent, canActivate: [AdminGuard], data: { permission: 'settings' } },

  { path: 'logs', component: LogsComponent, canActivate: [AdminGuard], data: { permission: 'logs' } },

  {path: 'files', component: FileManagerComponent, canActivate: [AdminGuard]},


  
  {path: 'login', component: SignInComponent},
  { path: 'not-found', component: NotFoundComponent },
  { path: '**', redirectTo: '/not-found' }

];